<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="p-2 text-left">
              <CAlert color="danger" class="mb-4"
                >Once you delete this account, you will no longer be able to log
                in again. If you wish to reactivate your account, please contact
                the administrator pickiddo, for assistance.</CAlert
              >
              <!-- <label style="text-align: left; left: 0" class="custom-label-note"
                >Enter Email</label
              >
              <br />
              <input
                type="text"
                class="custom-input-user"
                placeholder="eg. aliff.shukri@gmail.com"
                v-model="email"
              />
              <br />
              <br />
              <label style="text-align: left; left: 0" class="custom-label-note"
                >Enter Password</label
              >
              <input
                type="password"
                class="custom-input-user"
                placeholder="eg. alif123"
                v-model="password"
              /> -->
              <CCol sm="12">
                <div class="list-grade">
                  <div>
                    <label>Enter Email</label>
                    <br />
                    <CInput
                      type="text"
                      placeholder="eg. aliff.shukri@gmail.com"
                      v-model="email"
                    />
                  </div>
                </div>
                <div style="clear: both"></div>
                <hr />
                <div class="list-grade">
                  <div>
                    <label>Enter Password</label>
                    <br />
                    <CInput
                      type="password"
                      placeholder="eg. alif123"
                      v-model="password"
                    />
                  </div>
                </div>
                <br /><br /><br />
              </CCol>
              <div class="text-center">
                <CButton
                  color="info"
                  class="custom-btn-login-active mt-5"
                  @click="OpenPopup()"
                  block
                >
                  Delete</CButton
                >

                <CButton
                  color="warning"
                  class="btn-select-blue ml-2 mt-5"
                  block
                >
                  Cancel</CButton
                >
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
      <CModal
      :show.sync="ModalDelete"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="md"
      color="default"
    >
      Are you sure you want delete this account?
      <template #header>
        <h6 class="modal-title">Delete Account</h6>
        <CButtonClose @click="ModalDelete = false" class="text-dark"/>
      </template>
      <template #footer>
        <CButton @click="SubmitEmail()" color="success">Confirm</CButton>
        <CButton @click="ModalDelete = false" color="danger">Discard</CButton>
       
      </template>
      </CModal>
    </CContainer>

    


    <div class="bottom-center">
      <!-- <CButton
        color="info"
        class="custom-btn-login-active mt-5"
        @click="SubmitEmail()"
      >
        {{ buttonLabel }}</CButton
      > -->
    </div>
    <div class="header-top">Delete Account</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>
  
  <script>
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      email: "",
      password: "",
      buttonLabel: "Delete Account",
    
      ModalDelete: false,
    };
  },
  async mounted() {},
  methods: {
    OpenPopup()
    {
     this.ModalDelete = true;

    },
    SubmitEmail() {
      this.buttonLabel = "Processing";
      const formData = new FormData();
      formData.append("userEmail", this.email);
      formData.append("password", this.password);

      return this.$API
        .post(this.$DeleteAccount, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Successfully Delete").then(function () {});
            // this.GotoVerify(this.email);
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to delete").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.container-box {
  max-width: 335px;
  margin: 0 auto;
}

.container-box {
  max-width: 100% !important;
  margin: 0 auto;
}
.card-custom-web {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  height: 100vh;
  margin-top: 129px;
  background: #f9f9f9;
  -webkit-box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>